export default "__VITE_ASSET__DgxDK6Q3__"